import { render, staticRenderFns } from "./Scorm12.vue?vue&type=template&id=7c3847b4&scoped=true"
import script from "./Scorm12.vue?vue&type=script&lang=js"
export * from "./Scorm12.vue?vue&type=script&lang=js"
import style0 from "./Scorm12.vue?vue&type=style&index=0&id=7c3847b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3847b4",
  null
  
)

export default component.exports